import React, { useMemo, useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import './EmptyState.scss';

export const EmptyState = ({
  img = '',
  heading = 'Something went wrong!',
  subHeading = '',
  isPop = false,
  renderActions,
  imageWidth = '20rem',
  fullHeight = false,
  maxWidth = '40rem',
}) => {
  const [imageUploading, setImageUploading] = useState(true);
  let responsive = isPop ? 'responsive' : '';

  const uploadImage = () => {
    setImageUploading(false);
  };

  const height = useMemo(() => {
    if (fullHeight) return 'calc(100vh - 7rem)';
    return 'auto';
  }, [fullHeight]);

  return (
    <div
      className={`emptyStateContainer ${responsive}`}
      style={{ height: height }}
    >
      <div className='emptyState' style={{ maxWidth: maxWidth }}>
        {img && (
          <div className='emptyStateImg' style={{ width: imageWidth }}>
            {imageUploading ? <Shimmer height='auto' width='400px' /> : null}
            <img src={img} alt='' onLoad={uploadImage} />
          </div>
        )}
        <div className='emptyStateContent'>
          <p className='heading !tw-font-medium'>{heading}</p>
          <p className='subHeading !tw-font-medium'>{subHeading}</p>
        </div>
        {renderActions && renderActions()}
      </div>
    </div>
  );
};
